import { render, staticRenderFns } from "./language-preferences.vue?vue&type=template&id=7cea9ca2"
import script from "./language-preferences.vue?vue&type=script&lang=js"
export * from "./language-preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports